<div class="page">
  <app-page-header page-title="companies.detail.pageTitle"></app-page-header>
  <div class="page-content">
    <!-- DETAIL CARD -->
    <mat-card class="custom-card">
      <mat-card-title>{{ 'companies.detail.editTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false"  class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>

          <app-creator-updator-box [data]="company"></app-creator-updator-box>
          <!-- -->
          <div class="container-fluid box-contract" *ngIf="disclaimer" [ngClass]="{'d-none': !loggedUserMaster}">
            <div class="row">
              <div class="col-12 col-md-6">
                <mat-list dense class="left-aligned-mat-list">
                  <mat-list-item>
                    <strong class="pr-2">{{ 'companies.detail.contractApprovedAt' | translate }}:</strong>
                    {{ disclaimerAt | date:'dd LLL yyyy HH:mm' }}
                  </mat-list-item>
                  <mat-list-item>
                    <strong class="pr-2">{{ 'companies.detail.contractApprovedBy' | translate }}:</strong>
                    {{ disclaimerUser }}
                  </mat-list-item>
                </mat-list>
              </div> <!-- /.col -->
              <div class="col-12 col-md-6">
                <mat-list dense class="left-aligned-mat-list">
                  <mat-list-item>
                    <strong class="pr-2">{{ 'companies.detail.contractApproved' | translate }}:</strong>
                    <button class="mr-2" mat-stroked-button color="primary"
                      (click)="onGetContract()">
                      <mat-icon class="mr-1" fontSet="fal" fontIcon="fa-download"></mat-icon>
                      {{ 'companies.detail.downloadContract' | translate }}
                    </button>
                  </mat-list-item>
                </mat-list>
              </div> <!-- /.col -->
            </div> <!-- /.row -->
          </div> <!-- /.container -->
          <!-- -->

          <div class="form-wrapper mt-3">
            <form [formGroup]="form" (ngSubmit)="onFormSubmit(model)">
              <formly-form [form]="form" [fields]="anagraphicFields" [model]="model" [options]="options"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
              </mat-spinner-button>
            </form>
          </div> <!-- /.form-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- SAFETY VIDEOS FOR SUPPLIERS -->
    <mat-card class="custom-card mt-4" [hidden]="!safetyVideoSuppliersActive">
      <mat-card-title>{{ 'companies.detail.safetyVideoSuppliersCard.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.safetyVideoSuppliersCard.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="safetyVideoSuppliersCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="mt-2 mb-4">
            <button class="add-icon-button mr-2" color="primary" (click)="onSafetyVideoSuppliersPrintQRcode()" mat-flat-button
              matTooltip="{{ 'common.cta.printQr' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{ 'companies.detail.safetyVideoSuppliersCard.printQrcode' | translate }}
            </button>
            <button class="add-icon-button mr-2" color="accent" (click)="onVideoPopUp('SafetyVideoSuppliers')" mat-flat-button
              matTooltip="{{ 'companies.detail.safetyVideoSuppliersCard.showVideo' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-file-word"></mat-icon> {{ 'companies.detail.safetyVideoSuppliersCard.showVideo' | translate }}
            </button>
            <ng-container *ngIf="safetyVideoSuppliersQrcodeData">
              <qrcode class="d-none" id="safetyVideoSuppliersQrcodeDataImage" [qrdata]="safetyVideoSuppliersQrcodeData" [width]="150" [errorCorrectionLevel]="'H'"
                [elementType]="url"></qrcode>
            </ng-container>
            <button class="add-icon-button float-right" color="accent" (click)="onSafetyVideoSuppliersSendQrcodeByEmail()" mat-flat-button
              matTooltip="{{ 'companies.detail.safetyVideoSuppliersCard.sendQrcodeByEmail' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon> {{ 'companies.detail.safetyVideoSuppliersCard.sendQrcodeByEmail' | translate }}
            </button>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #safetyVideoSuppliersInput>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInputSafetyVideoSuppliers()"
                      class="reset-input-icon" *ngIf="safetyVideoSuppliersInput.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExportSafetyVideoSuppliers()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFiltersSafetyVideoSuppliers()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="is-loading" *ngIf="safetyVideoSuppliersDataSource.loading$ | async">
              <mat-spinner diameter="50"></mat-spinner>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="safetyVideoSuppliersDataSource" matSort #safetyVideoSuppliersSort="matSort" matSortActive="createdAt"
                matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.safetyVideoSuppliers.firstName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.firstName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoSuppliersFirstNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoSuppliers(safetyVideoSuppliersFirstNameFilter)" class="reset-input-icon"
                        *ngIf="safetyVideoSuppliersFirstNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.safetyVideoSuppliers.lastName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.lastName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoSuppliersLastNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterSafetyVideoSuppliers(safetyVideoSuppliersLastNameFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoSuppliersLastNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="companyName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'companies.fields.safetyVideoSuppliers.companyName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.companyName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoSuppliersCompanyNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterSafetyVideoSuppliers(safetyVideoSuppliersCompanyNameFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoSuppliersCompanyNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.safetyVideoSuppliers.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.createdAt | dateTimeFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="safetyVideoSuppliersCreatedAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoSuppliers(safetyVideoSuppliersCreatedAtFilter)" class="reset-input-icon"
                        *ngIf="safetyVideoSuppliersCreatedAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="safetyVideoSuppliersDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: safetyVideoSuppliersDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="safetyVideoSuppliersDisplayedColumns"></tr>
              </table>
              <mat-paginator #safetyVideoSuppliersPaginator [length]="safetyVideoSuppliersDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- SAFETY VIDEOS FOR RESIDENTS -->
    <mat-card class="custom-card mt-4" [hidden]="!safetyVideoResidentsActive">
      <mat-card-title>{{ 'companies.detail.safetyVideoResidentsCard.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.safetyVideoResidentsCard.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="safetyVideoResidentsCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="mt-2 mb-4">
            <button class="add-icon-button mr-2" color="primary" (click)="onSafetyVideoResidentsPrintQRcode()" mat-flat-button
              matTooltip="{{ 'common.cta.printQr' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{ 'companies.detail.safetyVideoResidentsCard.printQrcode' | translate }}
            </button>
            <button class="add-icon-button mr-2" color="accent" (click)="onVideoPopUp('SafetyVideoResidents')" mat-flat-button
              matTooltip="{{ 'companies.detail.safetyVideoResidentsCard.showVideo' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-file-word"></mat-icon> {{ 'companies.detail.safetyVideoResidentsCard.showVideo' | translate }}
            </button>
            <ng-container *ngIf="safetyVideoResidentsQrcodeData">
              <qrcode class="d-none" id="safetyVideoResidentsQrcodeDataImage" [qrdata]="safetyVideoResidentsQrcodeData" [width]="150" [errorCorrectionLevel]="'H'"
                [elementType]="url"></qrcode>
            </ng-container>
            <button class="add-icon-button float-right" color="accent" (click)="onSafetyVideoResidentsSendQrcodeByEmail()" mat-flat-button
              matTooltip="{{ 'companies.detail.safetyVideoResidentsCard.sendQrcodeByEmail' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon> {{ 'companies.detail.safetyVideoResidentsCard.sendQrcodeByEmail' | translate }}
            </button>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #safetyVideoResidentsInput>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInputSafetyVideoResidents()"
                      class="reset-input-icon" *ngIf="safetyVideoResidentsInput.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExportSafetyVideoResidents()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFiltersSafetyVideoResidents()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="is-loading" *ngIf="safetyVideoResidentsDataSource.loading$ | async">
              <mat-spinner diameter="50"></mat-spinner>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="safetyVideoResidentsDataSource" matSort #safetyVideoResidentsSort="matSort" matSortActive="createdAt"
                matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.safetyVideoResidents.firstName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.firstName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoResidentsFirstNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoResidents(safetyVideoResidentsFirstNameFilter)" class="reset-input-icon"
                        *ngIf="safetyVideoResidentsFirstNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.safetyVideoResidents.lastName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.lastName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoResidentsLastNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterSafetyVideoResidents(safetyVideoResidentsLastNameFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoResidentsLastNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="companyName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'companies.fields.safetyVideoResidents.companyName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.companyName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="safetyVideoResidentsCompanyNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterSafetyVideoResidents(safetyVideoResidentsCompanyNameFilter)"
                        class="reset-input-icon" *ngIf="safetyVideoResidentsCompanyNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.safetyVideoResidents.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.createdAt | dateTimeFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="safetyVideoResidentsCreatedAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterSafetyVideoResidents(safetyVideoResidentsCreatedAtFilter)" class="reset-input-icon"
                        *ngIf="safetyVideoResidentsCreatedAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="safetyVideoResidentsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: safetyVideoResidentsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="safetyVideoResidentsDisplayedColumns"></tr>
              </table>
              <mat-paginator #safetyVideoResidentsPaginator [length]="safetyVideoResidentsDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- FIRE SAFETY -->
    <mat-card class="custom-card mt-4" [hidden]="!fireSafetyActive">
      <mat-card-title>{{ 'companies.detail.fireSafetyDocsCard.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.fireSafetyDocsCard.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="fireSafetyDocsCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="mt-2 mb-2">
            <!-- <h6>{{ 'companies.fields.fireSafetyDefaultDocs.subtitle' | translate }}</h6> -->
          </div>
          <div class="table-wrapper">
            <div class="table-responsive">
              <table mat-table [dataSource]="fireSafetyDocsDefaultDataSource">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs"> # </th>
                  <td mat-cell *matCellDef="let element; let i = index"> {{ i + 1 }} </td>
                </ng-container>

                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef class="col-width col-width-30"> 
                    {{ 'companies.fields.fireSafetyDocs.name' | translate }} 
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
                </ng-container>

                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef> 
                    {{ 'companies.fields.fireSafetyDocs.description' | translate }} 
                  </th>
                  <td mat-cell *matCellDef="let element"> {{ element.description }} </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef class="col-width col-width-20"> 
                    {{ 'companies.fields.fireSafetyDocs.createdAt' | translate }} 
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center"> {{ element.createdAt | dateFormat}} </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onFireSafetyDocsViewQrcode(element)">{{ 'companies.fields.fireSafetyDocs.command.qrcode' | translate }}</button>
                      <button mat-menu-item (click)="onFireSafetyDocsPrintQrcode(element)">{{ 'companies.fields.fireSafetyDocs.command.printQrcode' | translate }}</button>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="fireSafetyDocsefaultDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: fireSafetyDocsefaultDisplayedColumns;"></tr>
              </table>

            </div>
          </div>
          <ng-container *ngIf="!loggedUserMaster || (fireSafetyDocsDataSource.loading$ | async) || (fireSafetyDocsDataSource.totalCount$ | async) > 0">
          <div class="mt-4 mb-2">
            <!-- <h6>{{ 'companies.fields.fireSafetyDocs.subtitle' | translate }}</h6> -->
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #fireSafetyDocsInput>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="fireSafetyDocsResetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onFireSafetyDocsExport()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onFireSafetyDocsResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="fireSafetyDocsDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="fireSafetyDocsDataSource" matSort #fireSafetyDocsSort="matSort" matSortActive="createdAt" 
                matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'companies.fields.fireSafetyDocs.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.name }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="fireSafetyDocsNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onFireSafetyDocsResetFilter(fireSafetyDocsNameFilter)"
                        class="reset-input-icon ml-n3" *ngIf="fireSafetyDocsNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.fireSafetyDocs.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="fireSafetyDocsDescriptionFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onFireSafetyDocsResetFilter(fireSafetyDocsDescriptionFilter)"
                        class="reset-input-icon" *ngIf="fireSafetyDocsDescriptionFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-width col-width-20">
                    {{ 'companies.fields.fireSafetyDocs.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.createdAt | dateFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="fireSafetyDocsCreatedAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onFireSafetyDocsResetFilter(fireSafetyDocsCreatedAtFilter)"
                        class="reset-input-icon" *ngIf="fireSafetyDocsCreatedAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                      <!-- <button mat-menu-item (click)="onFireSafetyDocsEdit(element)">{{ 'companies.fields.fireSafetyDocs.command.modify' | translate }}</button>
                      <button mat-menu-item (click)="onFireSafetyDocsDelete(element._id)">{{ 'companies.fields.fireSafetyDocs.command.delete' | translate }}</button>
                      <button mat-menu-item (click)="onFireSafetyDocsDownload(element)">{{ 'common.cta.downloadFile' | translate }}</button> -->
                      <button mat-menu-item (click)="onFireSafetyDocsViewQrcode(element)">{{ 'companies.fields.fireSafetyDocs.command.qrcode' | translate }}</button>
                      <button mat-menu-item (click)="onFireSafetyDocsPrintQrcode(element)">{{ 'companies.fields.fireSafetyDocs.command.printQrcode' | translate }}</button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="fireSafetyDocsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: fireSafetyDocsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="fireSafetyDocsDisplayedColumns"></tr>
              </table>
              <mat-paginator #fireSafetyDocsPaginator [length]="fireSafetyDocsDataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
          </ng-container>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- NOTA INFORMATIVA (independent additional service, not tied to Privacy / Privacy SAG) -->
    <mat-card class="custom-card mt-4" [hidden]="!informativeNoteActive">
      <mat-card-title>{{ 'companies.detail.privacyDocsCard.titleInformativeNote' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.privacyDocsCard.informativeNote.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="mt-2 mb-4 clearfix" *ngIf="loggedUserMaster">
            <div class="float-right">
              <button class="navigation-button mr-2" mat-flat-button color="primary" *ngIf="informativeNoteActive && loggedUserMaster"
                [disabled]="informativeNoteDocIsLoading" (click)="onInformativeNoteSendByEmail()"
                matTooltip="{{ 'companies.detail.privacyDocsCard.informativeNote.sendByEmailTooltip' | translate }}">
                <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon>
                {{ 'companies.detail.privacyDocsCard.informativeNote.sendByEmail' | translate }}
              </button>
              <button class="navigation-button" mat-flat-button color="primary" *ngIf="informativeNoteActive && loggedUserMaster"
                [disabled]="informativeNoteDocIsLoading" (click)="onInformativeNoteDownload()"
                matTooltip="{{ 'companies.detail.privacyDocsCard.informativeNote.generateTooltip' | translate }}">
                <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon>
                {{ 'companies.detail.privacyDocsCard.informativeNote.generate' | translate }}
              </button>
            </div>
          </div>
          <div class="table-wrapper">
            <div class="spinner-container" *ngIf="informativeNoteDocsDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="informativeNoteDocsDataSource" matSort #informativeNoteDocsSort="matSort"
                matSortActive="createdAt" matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyDocs.type' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ 'companies.detail.privacyDocsCard.informativeNote.docType' | translate }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.privacyDocs.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyDocs.createdAt' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.createdAt | dateFormat }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="informativeNoteDocsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #informativeNoteDocsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onPrivacyDocsAccess(element)">{{
                        'companies.fields.privacyDocs.command.access' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyDocsViewQrcode(element)">{{
                        'companies.fields.privacyDocs.command.qrcode' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyDocsViewLink(element)">{{
                        'companies.fields.privacyDocs.command.viewLink' | translate }}</button>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="privacyDocsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: privacyDocsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
              </table>
              <mat-paginator #informativeNoteDocsPaginator [length]="informativeNoteDocsDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- PRIVACY -->
    <mat-card class="custom-card mt-4" [hidden]="hiddenCardPrivacy">
      <mat-card-title>
        <span *ngIf="privacySagActive">{{ 'companies.detail.privacyDocsCard.titleSag' | translate }}</span>
        <span *ngIf="!privacySagActive">{{ 'companies.detail.privacyDocsCard.title' | translate }}</span>
      </mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.privacyDocsCard.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="privacyDocsCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper" [hidden]="!(privacySagActive || suppliers)">
            <div class="spinner-container" *ngIf="privacyDocsDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="privacyDocsDataSource" matSort #privacyDocsSort="matSort"
                matSortActive="createdAt" matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyDocs.type' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ 'companies.detail.privacyDocsCard.type.' + element.type | translate }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.privacyDocs.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyDocs.createdAt' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.createdAt | dateFormat }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="privacyDocsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #privacyDocsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onPrivacyDocsAccess(element)">{{
                        'companies.fields.privacyDocs.command.access' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyDocsViewQrcode(element)">{{
                        'companies.fields.privacyDocs.command.qrcode' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyDocsViewLink(element)">{{
                        'companies.fields.privacyDocs.command.viewLink' | translate }}</button>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="privacyDocsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: privacyDocsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
              </table>
              <mat-paginator #privacyDocsPaginator [length]="privacyDocsDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->

          <!-- PRIVACY DELLO STUDIO -->
          <div [hidden]="!privacySagActive && !privacyActive">
          <hr class="my-4">
          <h5>{{ 'companies.detail.privacyDocsCard.studioSection.title' | translate }}</h5>
          <div class="mt-2 mb-4">
            <button class="add-icon-button mr-2" color="primary" (click)="onPrivacyStudioDocsAddDoc()" mat-flat-button
              matTooltip="{{ 'companies.detail.privacyDocsCard.studioSection.add' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-plus-circle"></mat-icon>
              {{ 'companies.detail.privacyDocsCard.studioSection.add' | translate }}
            </button>
            <button class="navigation-button float-right mr-2" mat-flat-button color="accent"
              *ngIf="privacySagActive || suppliers" (click)="onPrivacyStudioDocsSendByEmail()">
              <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon>
              {{ 'companies.detail.privacyDocsCard.studioSection.sendByEmail' | translate }}
            </button>
            <button class="navigation-button float-right" mat-flat-button color="primary" *ngIf="privacySagActive"
              (click)="onOpenStudioPrivacyTemplatesDialog()"
              matTooltip="{{ 'companies.detail.privacyDocsCard.studioSection.downloadTemplatesTooltip' | translate }}">
              <mat-icon fontSet="fal" fontIcon="fa-file-word"></mat-icon>
              {{ 'companies.detail.privacyDocsCard.studioSection.downloadTemplates' | translate }}
            </button>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6"></div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onPrivacyStudioDocsExport()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onPrivacyStudioDocsResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="privacyStudioDocsDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="privacyStudioDocsDataSource" matSort #privacyStudioDocsSort="matSort"
                matSortActive="createdAt" matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="checkbox">
                  <th mat-header-cell *matHeaderCellDef class="col-width col-width-10">
                    {{ 'companies.fields.privacyStudioDocs.checkbox' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox (change)="onPrivacyStudioDocSelected(element, $event.checked)" class="checkbox-insert">
                    </mat-checkbox>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyStudioDocs.type' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ 'companies.fields.privacyStudioDocs.types.' + element.type | translate }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="privacyStudioDocsTypeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onPrivacyStudioDocsResetFilter(privacyStudioDocsTypeFilter)" class="reset-input-icon ml-n3"
                        *ngIf="privacyStudioDocsTypeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.privacyStudioDocs.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="privacyStudioDocsDescriptionFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onPrivacyStudioDocsResetFilter(privacyStudioDocsDescriptionFilter)" class="reset-input-icon"
                        *ngIf="privacyStudioDocsDescriptionFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.privacyStudioDocs.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.createdAt | dateFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dpPrivacyStudioDocs" (focus)="dpPrivacyStudioDocs.open()"
                        (click)="dpPrivacyStudioDocs.open()" readonly placeholder="{{ 'common.cta.select' | translate }}"
                        [formControl]="privacyStudioDocsCreatedAtFilter" style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onPrivacyStudioDocsResetFilter(privacyStudioDocsCreatedAtFilter)" class="reset-input-icon"
                        *ngIf="privacyStudioDocsCreatedAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dpPrivacyStudioDocs"></mat-datepicker-toggle>
                      <mat-datepicker #dpPrivacyStudioDocs></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="privacyStudioDocsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #privacyStudioDocsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onPrivacyStudioDocsEdit(element)">{{
                        'companies.fields.privacyStudioDocs.command.modify' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyStudioDocsDelete(element._id)">{{
                        'companies.fields.privacyStudioDocs.command.delete' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyStudioDocsDownload(element)">{{ 'common.cta.downloadFile' |
                        translate }}</button>
                      <button mat-menu-item (click)="onPrivacyStudioDocsViewQrcode(element)">{{
                        'companies.fields.privacyStudioDocs.command.qrcode' | translate }}</button>
                      <button mat-menu-item (click)="onPrivacyStudioDocsPrintQrcode(element)">{{
                        'companies.fields.privacyStudioDocs.command.printQrcode' | translate }}</button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="privacyStudioDocsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: privacyStudioDocsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="privacyStudioDocsDisplayedColumns"></tr>
              </table>
              <mat-paginator #privacyStudioDocsPaginator [length]="privacyStudioDocsDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
          </div> <!-- /PRIVACY DELLO STUDIO -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- STUDY ARCHIVE (always visible: not an additional service) -->
    <mat-card class="custom-card mt-4">
      <mat-card-title>{{ 'companies.detail.genericDocsDocsCard.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'companies.detail.genericDocsDocsCard.subtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="genericDocsCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="false" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="mt-2 mb-4">
            <button class="add-icon-button mr-2" color="primary" (click)="onGenericDocsAddDoc()" mat-flat-button
              matTooltip="{{ 'common.cta.add' | translate }}" matTooltipPosition="above">
              <mat-icon fontSet="fal" fontIcon="fa-qrcode"></mat-icon> {{ 'common.cta.add' | translate }}
            </button>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #genericDocsInput>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="genericDocsResetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onGenericDocsExport()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onGenericDocsResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="genericDocsDataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="genericDocsDataSource" matSort #genericDocsSort="matSort" matSortActive="createdAt" 
                matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'genericDocs.fields.name' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.name }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" >
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="genericDocsNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onGenericDocsResetFilter(genericDocsNameFilter)"
                        class="reset-input-icon ml-n3" *ngIf="genericDocsNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'genericDocs.fields.description' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="genericDocsDescriptionFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onGenericDocsResetFilter(genericDocsDescriptionFilter)"
                        class="reset-input-icon" *ngIf="genericDocsDescriptionFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header  class="col-width col-width-20">
                    {{ 'genericDocs.fields.createdAt' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    {{ element.createdAt | dateFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="genericDocsCreatedAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onGenericDocsResetFilter(genericDocsCreatedAtFilter)"
                        class="reset-input-icon" *ngIf="genericDocsCreatedAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="createdBy">
                  <th mat-header-cell *matHeaderCellDef class="col-width col-width-20">
                    {{ 'genericDocs.fields.createdBy' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span
                      *ngIf="element.files && element.files[0] && element.files[0].createdBy && element.files[0].createdBy.firstName; else genericDocsNoAuthor">
                      {{ element.files[0].createdBy.firstName }} {{ element.files[0].createdBy.lastName }}
                    </span>
                    <ng-template #genericDocsNoAuthor>{{ 'common.words.dashes' | translate }}</ng-template>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right pr-5" class="col-width col-width-10">
                    {{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">
                    <button [matMenuTriggerFor]="listsMenu" mat-raised-button color="primary"
                      matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                      {{ 'common.cta.open' | translate }}
                      <mat-icon fontSet="fal" fontIcon="fa-chevron-down"></mat-icon>
                    </button>
                    <mat-menu #listsMenu="matMenu" [hasBackdrop]="true">
                      <button mat-menu-item (click)="onGenericDocsEdit(element)">{{ 'genericDocs.list.modify' | translate }}</button>
                      <button mat-menu-item (click)="onGenericDocsDelete(element._id)">{{ 'genericDocs.list.delete' | translate }}</button>
                      <button mat-menu-item (click)="onGenericDocsDownload(element)">{{ 'common.cta.downloadFile' | translate }}</button>
                      <button mat-menu-item (click)="onGenericDocsViewQrcode(element)">{{ 'genericDocs.list.qrcode' | translate }}</button>
                      <button mat-menu-item (click)="onGenericDocsPrintQrcode(element)">{{ 'genericDocs.list.printQrcode' | translate }}</button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="genericDocsDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: genericDocsDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="genericDocsDisplayedColumns"></tr>
              </table>
              <mat-paginator #genericDocsPaginator [length]="genericDocsDataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->